import * as Sentry from "@sentry/react";
import React from "react";

import Surveys from "./Surveys";

import { getFeatureFlagQuery } from "../../../../hooks/useFeatureFlag";

import { currentUserQuery, rbacPermissionsQuery } from "../../../../api/queries";
import { SimplifiedQuery, dataLoader } from "../../../../api/queries/dataLoader";

// Data loader function
export const surveysLoader = () => {
	const queries: (() => SimplifiedQuery)[] = [getFeatureFlagQuery, () => rbacPermissionsQuery("survey")];

	return dataLoader([[currentUserQuery], queries]);
};

const SurveysPage = () => {
	return (
		<Sentry.ErrorBoundary fallback={undefined}>
			<Surveys />
		</Sentry.ErrorBoundary>
	);
};

export default SurveysPage;
